import React from 'react'
import { visualizeLoad } from "../../api/api";
import {MapToFilter} from "../../utils/mappings";
import {DefaultProps, RefTable} from "../RefTable";

export const HistoricCountryVATData = (props)=><RefTable {...props}/>;

HistoricCountryVATData.defaultProps = {
    ...DefaultProps,
    title: "Historic Country VAT Data",
    tableSchema: "historic_vat_data",
    tableName: "historic_vat_data",
    filterSchema: "historic_vat_data_filter",
    edit: false,
    add: false,
    tfootHeight: 50,
    headerChildHeight: 96,
    fetch: async (tableName, values, page = {})=>{
        const filters = MapToFilter(values)
        return await visualizeLoad({
            tableName: 'historic_vat_data',
            orderBy: ['timestamp desc'],
            filter:[...filters],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    },
}
